/** @jsx jsx */
import { jsx, BaseStyles } from "theme-ui";
import { Themed } from "@theme-ui/mdx";

import FluidImage from "../components/FluidImage";

const BlogPost = ({image, alt, title, author, date, content}) => {
  return (
    <article>

      <header>
        <FluidImage image={image} alt={alt} />
        <Themed.h1 sx={{mt: 3, mb: 1}}>
          {title}
        </Themed.h1>
        <div sx={{mb: 7}}>
          {`By ${author} on ${date}`}
        </div>
      </header>

      {/* BaseStyles needed to apply theme.styles to non-MDX markdown */}
      <BaseStyles>
        <section sx={{
          mb: 5,
          "& > p:first-of-type": {
            color: "textDark.1",
            fontWeight: 500
          },
          "& img": {
            // This is a workaround for broken image rendering in
            // gatsby-remark-images. It sometimes adds 1px too much bottom
            // padding to the placeholder div, and sets the image height to
            // 100%, which causes a stretched blurry image. By injecting
            // this style, we can force it not to stretch.
            height: "auto !important",
          }
        }} 
        dangerouslySetInnerHTML={{ __html: content }} 
        />
      </BaseStyles>

    </article>
  );

};

export default BlogPost;
